import React from 'react';
import { useParams } from "react-router-dom";
import { FaShoppingCart, FaTimes, FaPlus } from 'react-icons/fa';
import SidebarCartItem from './SidebarCartItem';
import PopularItemCard from './PopularItemCard';
import { currencySymbolLeft } from '../../../../functions/Functions';

const CartSidebar = ({ 
  isCartOpen, 
  setIsCartOpen, 
  cartItems, 
  handleAddToCart, 
  handleRemoveFromCart, 
  setInstructionModalState, 
  cartSubTotal, 
  cartTax, 
  cartTotal, 
  orderDetail, 
  loading, 
  handlePlaceOrder,
  popularItems,
  handleItemClick,
  showImages = true,
  getPaymentTaxRate
}) => {
  const { id, tableName, orderType } = useParams();

  return (
    <div className={`cart-sidebar bg-white shadow-lg ${isCartOpen ? 'open' : ''}`}>
      <div className="cart-header p-3 d-flex align-items-center justify-content-between" style={{ backgroundColor: 'var(--accent-color)' }}>
        <div className="my-0 text-white d-flex align-items-center font-weight-md cart-header-title"><FaShoppingCart className="text-white mr-2 cart-header-icon" /> Your Order</div>
        <button className="btn text-white p-0 d-flex align-items-center" onClick={() => setIsCartOpen(false)}>
          <FaTimes className="cart-close-icon" />
        </button>
      </div>
      
      <div className="cart-body p-3 flex-grow-1 overflow-auto" style={{ backgroundColor: '#f8fafc' }}>
        {Object.values(cartItems).length === 0 ? (
          <div className="text-center text-muted mt-5">
            <FaShoppingCart size={48} className="mb-3 opacity-25" />
            <p className="font-weight-md empty-cart-text">Your cart is empty.</p>
          </div>
        ) : (
          <div className="cart-items-list">
            {Object.values(cartItems).map(item => (
              <SidebarCartItem 
                key={item.id} 
                item={item} 
                onAddToCart={handleAddToCart}
                onRemoveFromCart={handleRemoveFromCart}
                onEditInstruction={(cartItem) => setInstructionModalState({ isOpen: true, item: cartItem })}
                showImage={showImages}
              />
            ))}
            
            <div className="add-more-items text-center mt-3 mb-4">
               <button className="btn btn-outline-secondary rounded-pill btn-sm w-100 py-2 fw-bold add-more-items-btn" onClick={() => setIsCartOpen(false)}>
                 <FaPlus className="mb-2"/> Add more items
               </button>
            </div>
            
            {popularItems && popularItems.length > 0 && (
              <div className="mt-4 pt-3 border-top" style={{ borderColor: '#e2e8f0' }}>
                <div className="d-flex align-items-center mb-3 px-1">
                  <span className="sidebar-item-price">🔥</span>
                  <div className="font-weight-md text-dark sidebar-item-name">Popular with your order</div>
                </div>
                <div className="d-flex overflow-auto pb-2 popular-scroll-container" style={{ gap: '10px' }}>
                  {popularItems.slice(0, 5).map(item => (
                    <PopularItemCard key={item.id} item={item} onClick={handleItemClick} isSidebar={true} showImage={showImages} />
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      
      {Object.values(cartItems).length > 0 && (
        <div className="cart-footer p-4 bg-white border-top shadow-lg" style={{ borderTopLeftRadius: '1.5rem', borderTopRightRadius: '1.5rem' }}>
          <div className="d-flex justify-content-between mb-2">
            <span className="cart-summary-text">Subtotal</span>
            <span className="cart-summary-text">{currencySymbolLeft()} {cartSubTotal}</span>
          </div>
          {cartTax ? (
            <div className="d-flex justify-content-between mb-3">
              <span className="cart-summary-text">Tax ({getPaymentTaxRate ? getPaymentTaxRate() : (orderDetail?.branch?.branch_tax ?? 0)}%)</span>
              <span className="cart-summary-text">{currencySymbolLeft()} {cartTax}</span>
            </div>
          ) : ""}
          <hr className="my-2" style={{background:"#d0d2d4"}}/>
          <div className="d-flex justify-content-between mb-3 font-weight-md">
            <span className="cart-total-text">Total</span>
            <span className="cart-total-text" style={{ color: 'var(--text-primary)' }}>{currencySymbolLeft()} {cartTotal}</span>
          </div>
          <button 
            disabled={loading}
            className="btn text-white w-100 rounded-pill d-flex justify-content-center align-items-center shadow place-order-btn"
            onClick={handlePlaceOrder}
          >
            {(orderType && orderDetail.branch?.qsr_card_payment) ?  "Proceed To Checkout" : "Place Order"}
          </button>
        </div>
      )}
    </div>
  );
};

export default React.memo(CartSidebar);
